// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Services
// State
import { AppState } from '../../../core/reducers';
import {
  DoctorActionTypes,
  DoctorsPageRequested,
  DoctorsPageLoaded,
  DoctorCreated,
  DoctorDeleted,
  DoctorUpdated,
  DoctorOnServerCreated,
  DoctorsActionToggleLoading,
  DoctorsPageToggleLoading,
  ThrowError,
  ClearErrors,
  DoctorOnServerUpdated,
  DoctorsPageCancelled,
  DoctorOnServerDeleted,
  FireDoctorSuccess,
  DoctorStatusOnServerUpdated,
  DoctorStatusUpdated,
  // DoctorStatusUpdated
} from '../_actions/doctor.actions';
import { Router } from '@angular/router';
import { DoctorService } from '../_services/doctor.service';

@Injectable()
export class DoctorEffects {
  showPageLoadingDistpatcher = new DoctorsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new DoctorsPageToggleLoading({ isLoading: false });

  showActionLoadingDistpatcher = new DoctorsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new DoctorsActionToggleLoading({ isLoading: false });

  // done
  @Effect()
  loadDoctorsPage$ = this.actions$.pipe(
    ofType<DoctorsPageRequested>(DoctorActionTypes.DoctorsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.doctor.findDoctors(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new DoctorsPageCancelled();
            } else {
              this.store.dispatch(new ThrowError({ error: response[0].error }));
              return new DoctorsPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearErrors());
            return new DoctorsPageLoaded({
              doctors: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteDoctor$ = this.actions$.pipe(
    ofType<DoctorOnServerDeleted>(DoctorActionTypes.DoctorOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.doctor.deleteDoctor(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new DoctorDeleted(payload);
        }),
      );
    }),
  );

  @Effect()
  updateDoctor$ = this.actions$.pipe(
    ofType<DoctorOnServerUpdated>(DoctorActionTypes.DoctorOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.doctor.updateDoctor(payload.doctor).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res.error) {
            return new ThrowError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearErrors());
            return new DoctorUpdated(payload);
          }
        }),
      );
    }),
  );

  @Effect()
  createDoctor$ = this.actions$.pipe(
    ofType<DoctorOnServerCreated>(DoctorActionTypes.DoctorOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.doctor.createDoctor(payload.doctor).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res.status === 201) {
            this.store.dispatch(new ClearErrors());
            this.store.dispatch(
              new FireDoctorSuccess({ action_type: DoctorActionTypes.DoctorCreated }),
            );
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            return new DoctorCreated({ doctor: res.body.data });
          } else {
            return new ThrowError({ error: res });
          }
        }),
      );
    }),
  );

  @Effect() updateDoctorStatus$ = this.actions$.pipe(
    ofType<DoctorStatusOnServerUpdated>(DoctorActionTypes.DoctorStatusOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.doctor.updateDoctorStatus(payload.id, payload.is_active).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new DoctorStatusUpdated(payload);
        }),
      );
    }),
  );
  constructor(
    private actions$: Actions,
    private doctor: DoctorService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
